import "./App.css";
import "./app/Admin/Styles/main.css";
import "./app/Admin/Styles/responsive.css";
import "../src/app/Awards/Atoms/TableTest.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Login from "./app/Login/Pages/Login";
import SecondApprover from "./app/Awards/Pages/SecondApprover";
import FirstApprover from "./app/Awards/Pages/FirstApprover";
import { MsalProvider, useMsal, useIsAuthenticated } from "@azure/msal-react";
import { InteractionStatus } from "@azure/msal-browser";
import { useEffect, useState } from "react";
import FirstApproverTeam from "./app/Awards/Pages/FirstApproverTeam";
import SecondApproverTeam from "./app/Awards/Pages/SecondApproverTeam";
import AdminPage from "./app/Awards/Pages/AdminPage";
import ManagerReview from "./app/Awards/Pages/ManagerReview";
import ManagerReviewTeam from "./app/Awards/Pages/ManagerReviewTeam";
import Stackranking from "./app/Awards/Pages/StackRanking";
import StackrankingTeam from "./app/Awards/Pages/StackRankingTeam";
import SuperAdmin from "./app/Awards/Pages/SuperAdmin";
import SuperAdminTeam from "./app/Awards/Pages/SuperAdminTeam";
import AdminDashboard from "./app/Awards/Pages/AdminDashboard";
import TechnicalErrorPage from "./app/Awards/Pages/TechnicalErrorPage";
import useMsalInitialization from "./app/useMsalInitialization";
import NoAccessPage from "./app/Awards/Pages/NoAccessPage";
import Dashboard from "./app/Awards/Pages/Dashboard";
import AdminViewIndividual from "./app/Awards/Pages/AdminViewIndividual";
import AdminViewTeam from "./app/Awards/Pages/AdminViewTeam";
import Nomination from "./app/Awards/Pages/Nomination";
import HomePage from "./app/Awards/Pages/HomePage";
import ApteanRewardsHomePage from "./app/Awards/Pages/ApteanRewardsHomePage";
import SSOAuthenticate from "./app/SSOAuthenticate/SSOAuthenticate";
import NominationForm from "./app/Awards/Pages/NominationForm";
import MainPage from "./app/Awards/Pages/MainPage";
import UploadEcard from './app/Awards/Pages/UploadEcard';
import UploadCoreEcards from './app/Awards/Pages/UploadCoreEcards';
import Feeds from './app/Awards/Pages/Feeds';
// import Moments from './app/Awards/Organism/Moments';
import PostAnniversaryWishForm from "./app/Awards/Organism/PostAnniversaryWishForm";
import ShowUserPoints from './app/Awards/Pages/ShowUserPoints';
import ManagerActions from './app/Awards/Pages/ManagerActions';
import PeersCommentsComponent from './app/Awards/Pages/PeerComments';

import { Result } from 'antd';
import AwardsPage from './app/Awards/Pages/AwardsPage';
import ApteanAwardsSection from './app/Awards/Organism/ApteanAwardsSection';
import AuthWrapper from './AuthWrapper';
import WallOfFame from "./app/Awards/Pages/WallOfFame";
import AdminPages from "./app/Awards/Pages/AdminPages";
import ApteanCommunique from "./app/Awards/Organism/ApteanCommunique";
import ViewCommunique from "./app/Awards/Organism/ViewCommuniqueSingleItem";
import ViewNotification from "./app/Awards/Organism/ViewNotification";
import LeaderBoard from "./app/Awards/Pages/LeaderBoard";
import Moments from "./app/Awards/Pages/Moments";
import './i18n';
import CountryFlagDropdown from './app/Awards/Organism/CountryFlagDropdown';
import HelpPage from './app/Awards/Pages/HelpPage';
import ViewHelpDetails from './app/Awards/Pages/ViewHelpDetails';
import WomensMessageWall from './app/Awards/Pages/WomensMessageWall';
import ReviewHubPage from './app/Awards/Pages/ReviewHubPage';

function App({ msalInstance }: { msalInstance: any }) {
  const isMsalInitialized = useMsalInitialization(msalInstance);

  if (!isMsalInitialized) {
    return <div>Loading...</div>;
  }

  return (
    <MsalProvider instance={msalInstance}>
      <Pages />
    </MsalProvider>
  );
}

const Pages = () => {
  const { instance, inProgress } = useMsal();
  const isAuthenticated = useIsAuthenticated();
  const [isFramed, setIsFramed] = useState(false);

  useEffect(() => {
    if (window.self !== window.top) {
      if (window.top) {
        setIsFramed(true);
      }
    }
    // Only attempt silent SSO when MSAL is idle. Firing it mid-redirect throws
    // interaction_in_progress and competes with AuthWrapper's loginRedirect,
    // which slows down the sign-in.
    if (!isAuthenticated && inProgress === InteractionStatus.None) {
      // Get all accounts to check if we have any
      const accounts = instance.getAllAccounts();
      
      if (accounts && accounts.length > 0) {
        // We have accounts, try silent SSO
        instance
          .ssoSilent({
            scopes: ["User.Read", "User.Read.All"],
            account: accounts[0],
          })
          .then((response) => {
            if (response.account) {
              instance.setActiveAccount(response.account);
            }
          })
          .catch((error) => {
            console.log("Silent SSO failed with error", error);
          });
      } else {
        // No accounts available, silent SSO will fail without account parameter
        console.log("No accounts available for silent SSO");
      }
    }
  }, [instance, isAuthenticated, inProgress]);

  if (isFramed) {
    return (
      <Result
        status="403"
        title="403"
        subTitle="Sorry, you do not have access to this application."
      />
    );
  };

  return (
    <BrowserRouter basename="/awards">
      <Routes>
        <Route path="/" element={<AuthWrapper><ApteanRewardsHomePage /></AuthWrapper>}></Route>


        <Route path="/login" element={<AuthWrapper><Login /></AuthWrapper>}></Route>
        {/* <Route path="/home1" element={<AuthWrapper><HomePage /></AuthWrapper>}></Route> */}
        <Route path="/dashboard" element={<AuthWrapper><Dashboard /></AuthWrapper>}></Route>
        <Route path="/admindashboard1" element={<AuthWrapper><AdminPage /></AuthWrapper>}></Route>
        {/* Legacy review routes — unchanged for backward compatibility */}
        <Route path="/review/pm/individual" element={<AuthWrapper><ManagerReview /></AuthWrapper>}></Route>
        <Route path="/review/pm/team" element={<AuthWrapper><ManagerReviewTeam /></AuthWrapper>}></Route>
        <Route path="/review/level1/individual" element={<AuthWrapper><FirstApprover /></AuthWrapper>}></Route>
        <Route path="/review/level1/team" element={<AuthWrapper><FirstApproverTeam /></AuthWrapper>}></Route>
        <Route path="/review/level2/individual" element={<AuthWrapper><SecondApprover /></AuthWrapper>}></Route>
        <Route path="/review/level2/team" element={<AuthWrapper><SecondApproverTeam /></AuthWrapper>}></Route>
        <Route path="/review/stack/individual" element={<AuthWrapper><Stackranking /></AuthWrapper>}></Route>
        <Route path="/review/stack/team" element={<AuthWrapper><StackrankingTeam /></AuthWrapper>}></Route>
        <Route path="/review/final/individual" element={<AuthWrapper><SuperAdmin /></AuthWrapper>}></Route>
        <Route path="/review/final/team" element={<AuthWrapper><SuperAdminTeam /></AuthWrapper>}></Route>
        {/* New Review Hub — all review routes with matching website UI */}
        <Route path="/review-hub" element={<AuthWrapper><ReviewHubPage /></AuthWrapper>}></Route>
        <Route path="/review-hub/pm/individual" element={<AuthWrapper><ReviewHubPage /></AuthWrapper>}></Route>
        <Route path="/review-hub/pm/team" element={<AuthWrapper><ReviewHubPage /></AuthWrapper>}></Route>
        <Route path="/review-hub/level1/individual" element={<AuthWrapper><ReviewHubPage /></AuthWrapper>}></Route>
        <Route path="/review-hub/level1/team" element={<AuthWrapper><ReviewHubPage /></AuthWrapper>}></Route>
        <Route path="/review-hub/level2/individual" element={<AuthWrapper><ReviewHubPage /></AuthWrapper>}></Route>
        <Route path="/review-hub/level2/team" element={<AuthWrapper><ReviewHubPage /></AuthWrapper>}></Route>
        <Route path="/review-hub/stack/individual" element={<AuthWrapper><ReviewHubPage /></AuthWrapper>}></Route>
        <Route path="/review-hub/final/individual" element={<AuthWrapper><ReviewHubPage /></AuthWrapper>}></Route>
        <Route path="/review-hub/final/team" element={<AuthWrapper><ReviewHubPage /></AuthWrapper>}></Route>
        <Route path="/admin/view/individual" element={<AuthWrapper><AdminViewIndividual /></AuthWrapper>}></Route>
        <Route path="/admin/view/team" element={<AuthWrapper><AdminViewTeam /></AuthWrapper>}></Route>
        {/* <Route path="/nomination" element={<AuthWrapper><Nomination /></AuthWrapper>}></Route> */}
        {/* <Route path="/nomination-form" element={<AuthWrapper><NominationForm /></AuthWrapper>}></Route> */}


        <Route path="/awards-page" element={<AuthWrapper><AwardsPage /></AuthWrapper>}></Route>
        <Route path="/feeds" element={<AuthWrapper><Feeds /></AuthWrapper>}></Route>
        <Route path="/points" element={<AuthWrapper><ShowUserPoints /></AuthWrapper>}></Route>
        <Route path="/manager-actions" element={<AuthWrapper><ManagerActions /></AuthWrapper>}></Route>
        <Route path="/additional-reviewer" element={<AuthWrapper><PeersCommentsComponent /></AuthWrapper>}></Route>
        <Route path="/home" element={<AuthWrapper><ApteanRewardsHomePage /></AuthWrapper>}></Route>
        <Route path="no-access" element={<NoAccessPage />}></Route>
        <Route path="/ApteanAwardsSection" element={<AuthWrapper><ApteanAwardsSection /></AuthWrapper>}></Route>
        {/* <Route  path="/Moments"  element={<AuthWrapper><Moments /></AuthWrapper>}></Route> */}
        <Route path="/PostAnniversaryWishForm" element={<AuthWrapper><PostAnniversaryWishForm /></AuthWrapper>}></Route>
        {/* <Route  path="/mainpage"  element={<AuthWrapper><MainPage /></AuthWrapper>}></Route> */}
        <Route path="/WallOfFame" element={<AuthWrapper><WallOfFame /></AuthWrapper>}></Route>
        <Route path="/ApteanCommunique" element={<AuthWrapper><ApteanCommunique /></AuthWrapper>}></Route>
        <Route path="/ViewCommunique" element={<AuthWrapper><ViewCommunique /></AuthWrapper>}></Route>
        <Route path="/technical-error" Component={TechnicalErrorPage} />
        <Route path="/admindashboard" element={<AuthWrapper><AdminPages /></AuthWrapper>}></Route>
        <Route path="/ViewNotification" element={<AuthWrapper><ViewNotification /></AuthWrapper>}></Route>
        <Route path="/leaderBoard" element={<AuthWrapper><LeaderBoard /></AuthWrapper>}></Route>
        <Route path="/moments" element={<AuthWrapper><Moments /></AuthWrapper>}></Route>
        <Route path="/CountryFlagDropdown" element={<AuthWrapper><CountryFlagDropdown /></AuthWrapper>}></Route>
        <Route path="/helpdata" element={<AuthWrapper><HelpPage /></AuthWrapper>}></Route>
        <Route path="/viewhelpdetails" element={<AuthWrapper><ViewHelpDetails /></AuthWrapper>}></Route>
        <Route path="/womens-message-wall" element={<AuthWrapper><WomensMessageWall /></AuthWrapper>}></Route>

        <Route path="*" Component={TechnicalErrorPage} />{" "}
      </Routes>
    </BrowserRouter>
  );
};


export default App;